export const Paginasi = ({ data, onHalaman, testid }) => {
  if (!data || data.total <= data.ukuran) {
    return null;
  }

  return (
    <div
      className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t pt-4 text-xs"
      data-testid={`${testid}-paginasi`}
    >
      <span className="text-muted-foreground" data-testid={`${testid}-ringkasan`}>
        Halaman {data.halaman} · {data.total} catatan
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          data-testid={`${testid}-sebelumnya`}
          disabled={data.halaman === 1}
          onClick={() => onHalaman(data.halaman - 1)}
          className="tombol-garis px-3 py-1.5 rounded disabled:opacity-50"
        >
          Sebelumnya
        </button>
        <button
          type="button"
          data-testid={`${testid}-berikutnya`}
          disabled={!data.ada_berikutnya}
          onClick={() => onHalaman(data.halaman + 1)}
          className="tombol-garis px-3 py-1.5 rounded disabled:opacity-50"
        >
          Berikutnya
        </button>
      </div>
    </div>
  );
};